/**
 * 四舍五入(转换值, 保留位数[默认2])
 * 注意: 1.00会返回1；1.10返回1.1 如作为前端数据展示，可用roundStr
 * @param {number} value 需转换的值
 * @param {number} [saveLength=2]
 * @returns {number}
 */
export function round(value, saveLength = 2) {
  value = parseFloat(value)
  saveLength = parseFloat(saveLength)
  let magnification = Math.pow(10, saveLength)
  let temp = value * magnification
  temp = Math.round(temp)
  return temp / magnification
}
/**
 * 四舍五入，输出字符串格式(转换值, 保留位数[默认2])
 * 注意: 返回结果为字符串，需要数字可用round
 * @param {number} value
 * @param {number} [saveLength=2]
 * @returns {string}
 */
export function roundString(value, saveLength = 2) {
  return round(value, saveLength).toFixed(saveLength)
}

// 基金风险等级
export function getFunRiskLevel(value) {
  if (value == '1') {
    return '低风险'
  }
  if (value == '2') {
    return '中低风险'
  }
  if (value == '3') {
    return '中风险'
  }
  if (value == '4') {
    return '中高风险'
  }
  if (value == '5') {
    return '高风险'
  }
}

/* 代销理财业绩比较基准 */
export const RATETEXT = {
  0: '成立以来年化',
  1: '上一周期到期年化收益率',
  2: '近7日年化收益率',
  3: '万份收益',
  4: '近1月年化收益率',
  5: '近3月年化收益率',
  6: '近6月年化收益率',
  7: '近1年年化收益率',
  8: '业绩比较基准',
  9: '自产品成立以来年化收益率',
}

export const RISK_INTRO_TEXT = {
  2: '安⼼稳健',
  3: '稳中进取',
  4: '进取投资',
}
export const RISK_TARGET = {
  2: ['追求较低波动和风险', '追求安⼼'],
  3: ['具备一定风险承受力', '追求长盈'],
  4: ['具备一定风险承受力', '追求长盈'],
}

export const FINANCE_PROD_TYPE = {
  0: '保本固定收益类',
  1: '保本浮动收益类',
  2: '非保本浮动收益类',
  3: '非保本净值产品类',
}
// 币种
export const CRCYCD = {
  CNY: '人民币',
  HKD: '港币',
  USD: '美元',
  GBP: '英镑',
  CHF: '瑞士法郎',
  SGD: '新加坡元',
  JPY: '日元',
  CAD: '加元',
  AUD: '澳元',
  EUR: '欧元',
  KRW: '韩元',
  RUB: '卢布',
}

// 币种枚举
export const FINDSUBCION = function (data) {
  switch (data) {
    case '01':
      return '人民币'
    case '12':
      return '英镑'
    case '13':
      return '港币'
    case '14':
      return '美元'
    case '15':
      return '瑞士法郎'
    case '18':
      return '新加坡元'
    case '27':
      return '日元'
    case '28':
      return '加元'
    case '29':
      return '澳元'
    case '38':
      return '欧元'
    case '43':
      return '韩元'
    case '90':
      return '卢布'
  }
}

/**
 * 把Number四舍五入为指定小数位数的数字字符串（解决原toFixed四舍五入问题）
 * @param {number} [len=0] 保留小数位数
 * @param {boolean} [round=true] 是否四舍五入（默认进行四舍五入）
 * @param {boolean} [padding=true] 有效数字不足预设小数位数时是否后补0（默认后补）如：_toFixed(1.1,3,true,true) = "1.100"  ;   _toFixed(1.1,3,true,false) = "1.1"
 * @returns {string}
 * @example _toFixed(1.335,2);
 */
export function _toFixed(num, len = 2, round = true, padding = true) {
  num = Number(num)
  if (len < 0) {
    throw new RangeError('digits argument must be between 0 and 100')
  }
  let numStr = String(num) // 数字转字符串
  let pointIndex = numStr.indexOf('.') // 小数点下标
  let preNumIndex = pointIndex + len + 1 // 保留位后一位数字下标
  if (numStr.includes('e') || pointIndex === -1) {
    // 遇到科学表示法或整数，直接返回原生toFixed处理结果
    return num.toFixed(len)
  }
  let addZeroCount = len - (numStr.length - pointIndex - 1) // 需补0的个数
  if (addZeroCount > 0) {
    numStr += '0'.repeat(addZeroCount) // 小数位不足后补0
  }
  let numCut = Math.abs(numStr.substring(0, preNumIndex)) // 截取保留位（含）前的所有字符
  let res =
    (num < 0 ? '-' : '') +
    (round && numStr[preNumIndex] >= 5
      ? numCut + 1 / Math.pow(10, len)
      : numCut
    ).toFixed(len) // 判断预期小数位后一位是否大于等于5，是则进位
  return padding ? res : String(Number(res))
}

/**
 * 数字金额格式化，常用场景在过滤器中
 * @param {String|Number} 金额数字，字符串或者数字类型
 *
 * @param {String}        货币符号，默认¥
 * @param {Number}        小数点后精确的位数，默认2
 * @return {String}       加上了,逗号分隔符和小数点.后的字符串
 */
export function currencyFormat(value = '', currencySign = '¥', decimals = 2) {
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  const stringified = Math.abs(value).toFixed(decimals)
  const _int = decimals ? stringified.slice(0, -1 - decimals) : stringified
  const i = _int.length % 3
  const head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : ''
  const _float = decimals ? stringified.slice(-1 - decimals) : ''
  const sign = value < 0 ? '-' : ''
  const digitsRE = /(\d{3})(?=\d)/g
  return (
    sign + currencySign + head + _int.slice(i).replace(digitsRE, '$1,') + _float
  )
}

export function formatDate(date, rule) {
  let fmt = rule || 'yyyy-MM-dd hh:mm:ss'
  date = new Date(date)
  const o = {
    'y+': date.getFullYear(),
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const val = o[k] + ''
      fmt = fmt.replace(RegExp.$1, val >= 10 ? val : '0' + val)
    }
  }
  console.log(fmt, 'fmt')
  return fmt
}

// 产品通用购买按钮跳转事件
export function handleBuy() {
  // 前往个人网银
  // window.open('https://perbank.ghbank.com.cn/perbank/#/login')
  window.open(
    'https://perbank.ghbank.com.cn/perbank/static/images/integration/financeProShare/#/download'
  )
}

export const urls = {
  首页: process.env.VUE_APP_WEBURL,
  零售金融: `${process.env.VUE_APP_WEBURL}lsjr/`,
  // 金融信息: '/pub/hx/jrxx',
  客户服务: `${process.env.VUE_APP_WEBURL}khfw/`,
  财富管理: `${process.env.VUE_APP_WEBURL}lsjr/cfgl/`,
  个人存款: `${process.env.VUE_APP_WEBURL}lsjr/cfgl/grck/`,
  华兴特色存款: `${process.env.VUE_APP_WEBURL}lsjr/cfgl/grck/hxtsck/`,
  传统储蓄存款: `${process.env.VUE_APP_WEBURL}lsjr/cfgl/grck/ctcxck/`,
  投资理财: `${process.env.VUE_APP_WEBURL}lsjr/cfgl/tzlc/`,
  存贷利率: `${process.env.VUE_APP_WEBURL}khfw/ckll/`,
  贷款利率: `${process.env.VUE_APP_WEBURL}khfw/dkll/`,
  产品公告: `${process.env.VUE_APP_WEBURL}lsjr/cpgg/`,
  私人银行: `${process.env.VUE_APP_WEBURL}lsjr/cfgl/sryx/`,
  外汇: `${process.env.VUE_APP_WEBURL}khfw/wh/`
}
